// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import "@bg/App/Libraries";
import "@bg/App/Store/Reducers";
import "@bgs/XDL";
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";

// eslint-disable-next-line spire/fenced-imports
import { loadEditorTemplates } from "@insite/shell-public/EditorTemplatesLoader";

// this registers any custom editor templates that are used by custom pages/widgets
const templates = require.context("../../bg/src/App/EditorTemplates", true, /\.tsx$/);
const onHotTemplateReplace = loadEditorTemplates(templates);
if (module.hot) {
    module.hot.accept(templates.id, () => {
        onHotTemplateReplace(require.context("../../bg/src/App/EditorTemplates", true, /\.tsx$/));
    });
}

// load all widgets. Without this they won't be included in the bundle
const widgets = require.context("../../bg/src/App/Widgets", true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const onHotWidgetReplace = addWidgetsFromContext(widgets);

// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(widgets.id, () =>
        onHotWidgetReplace(require.context("../../bg/src/App/Widgets", true, /\.tsx$/)),
    );
}

// hotReload BGS custom widgets and replace it with BG if found
const BGSwidgets = require.context("./App/Widgets", true, /\.tsx$/);
const onBGSHotWidgetReplace = addWidgetsFromContext(BGSwidgets);

// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(BGSwidgets.id, () => onBGSHotWidgetReplace(require.context("./App/Widgets", true, /\.tsx$/)));
}

// load all pages. Without this they won't be included in the bundle
const pages = require.context("../../bg/src/App/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);

// ensure HMR works for custom pages
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("../../bg/src/App/Pages", true, /\.tsx$/)));
}

// hotReload BGS custom widgets and replace it with BG if found
const BGSpages = require.context("./App/Pages", true, /\.tsx$/);
const onBGSHotPageReplace = addPagesFromContext(BGSpages);

// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(BGSpages.id, () => onBGSHotPageReplace(require.context("./App/Pages", true, /\.tsx$/)));
}

// load all handlers. They could be loaded individually instead.
// in case a custom-spcific blueprint change on handlers,we need to use BLUEPRINT_NAME inside bg handlers
let handlers = require.context("../../bg/src/App/Handlers", true); // Recursively get all handler modifications
const BGShandlers = require.context("./App/Handlers", true);
handlers.keys().forEach(key => handlers(key)); // Load the handler modifications.

if (BGShandlers.keys().length > 0) {
    handlers = require.context("./App/Handlers", true);
    handlers.keys().forEach(key => handlers(key));
}

// load all widget extensions. They could be loaded individually instead
let widgetExtensions = require.context("../../bg/src/App/WidgetExtensions", true);
const BGSwidgetExtensions = require.context("./App/WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

if (BGSwidgetExtensions.keys().length > 0) {
    widgetExtensions = require.context("./App/WidgetExtensions", true);
    widgetExtensions.keys().forEach(key => widgetExtensions(key));
}

// load all component extensions extensions. They could be loaded individually instead
let componentExtensions = require.context("../../bg/src/App/ComponentExtensions", true);
const BGScomponentExtensions = require.context("./App/ComponentExtensions", true);
componentExtensions.keys().forEach(key => componentExtensions(key));

if (BGScomponentExtensions.keys().length > 0) {
    componentExtensions = require.context("./App/ComponentExtensions", true);
    componentExtensions.keys().forEach(key => componentExtensions(key));
}
